import { AgResourceLanguage } from '../types';
import { subscriptionList as EnUsSubscriptionList } from '../en-us/subscriptionList';

export const subscriptionList: AgResourceLanguage['subscriptionList'] = {
  ...EnUsSubscriptionList,
  showCheckboxLabel: 'Visa endast aktiva abonnemang',
  emptyState: {
    title: 'Skapa ditt första abonnemang',
    text: `Det verkar som att du inte har gjort något köp ännu. Få heltäckande näring och stöd för tarmhälsa i en enkel skopa.`,
    button: 'Få Din AG1'
  },
  subscriptionCard: {
    titleOrder: 'Nästa Beställning:',
    titleSubscription: 'Abonnemangsprodukter:',
    activeLabel: 'Aktiv',
    cancelLabel: 'Avbrutet',
    frequencyTitle: 'Frekvens:',
    frequencyDayText: 'Varje',
    manageSubscriptionButton: 'Hantera Abonnemang',
    subscriptionDetailsButton: 'Abonnemangsdetaljer',
    reactivateButton: 'Återaktivera',
    orderDateLabel: 'Beställningsdatum:',
    orderTotalLabel: 'Totalt för Beställning:',
    productsSubtitle: 'Produkter:',
    subscriptionDetailsSubtitle: 'Abonnemangsdetaljer'
  },
  cancelList: {
    title: 'Avbrutna Abonnemang',
    description: `Återaktivera ditt abonnemang för att få AG1 enligt ditt schema. När ditt abonnemang är aktivt kan du ändra dina preferenser och handla hela sortimentet av AG1-produkter.`
  }
};
